import { Component, OnInit,AfterViewInit ,OnDestroy,ViewChild} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import * as firebase from 'firebase';
import{ServicioFechasQueryService} from '../servicio-fechas-query.service'
import {ModalDataUsuarioComponent } from '../modal-data-usuario/modal-data-usuario.component'
import { NgxChartsModule } from '@swimlane/ngx-charts';
import {ServiDataUnidadNegocioServiceService}from '../servi-data-unidad-negocio-service.service'
import {ModalAccionesEmpresaComponent } from '../modal-acciones-empresa/modal-acciones-empresa.component'
import { ExcelServiceService } from '../excel-service.service';

@Component({
  selector: 'app-componente-data3',
  templateUrl: './componente-data3.component.html',
  styleUrls: ['./componente-data3.component.scss']
})
export class ComponenteData3Component implements OnInit{

  statuslimpio=true
  arraydelocaciones=[];
  botondisabled=true
  cuenca=''
  locacion=''
  alertaActiva=false
  mensajeAlerta='';
  tipodeAlerta='';
  unidadDeNegocioSeleccionada=''



  dataChart1
  dataChart2
  dataChart3
  dataChart4
  

  constructor(private modalService: NgbModal, public servicioFechasQueryService:ServicioFechasQueryService,public serviDataUnidadNegocioServiceService:ServiDataUnidadNegocioServiceService,private excelServiceService:ExcelServiceService) { }

  ngOnInit(): void {
   
  }

  nuevoReporte(){
    this.serviDataUnidadNegocioServiceService.dataChart1=this.serviDataUnidadNegocioServiceService.dataChart1Default
    this.serviDataUnidadNegocioServiceService.dataChart2=this.serviDataUnidadNegocioServiceService.dataChart2Default
    this.serviDataUnidadNegocioServiceService.dataChart3=this.serviDataUnidadNegocioServiceService.dataChart3Default
    this.serviDataUnidadNegocioServiceService.dataChart4=this.serviDataUnidadNegocioServiceService.dataChart4Default

    this.arraydelocaciones=[];
    this.cuenca=''
    this.locacion=''
    this.dataChart1=undefined
    this.dataChart2=undefined
    this.dataChart3=undefined
    this.dataChart4=undefined
    this.statuslimpio=true
  }





  generarReporte(){
    this.alertaActiva=true
    this.statuslimpio=false;
    this.serviDataUnidadNegocioServiceService.queryChart1((respuestadataChart1,respuestaChart2,respuestaChart3, respuestaChart4)=>{
      this.dataChart1 = respuestadataChart1
      this.dataChart2 = respuestaChart2
      this.dataChart3 = respuestaChart3
      this.dataChart4 = respuestaChart4
      this.alertaActiva=false

      console.log(this.dataChart1)

    })
  }
  


  //OPCIONES GRAFICO 1

  // options
  showXAxis: boolean = true;
  showYAxis: boolean = true;
  gradient: boolean = false;
  showLegend: boolean = false;
  showXAxisLabel: boolean = true;
  yAxisLabel: string = 'Status';
  showYAxisLabel: boolean = true;
  xAxisLabel: string = 'Número de permisos';

  colorScheme = {
    domain: ['#f8961e', '#90be6d', '#f94144', '#577590','#184e77','#43AA8B','#EF7A1A']
  };

  onSelect(data): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }





    //OPCIONES GRAFICO 2
    //chart de numero solo
    view: any[] = [250, 180];
    cardColor: string = '#0f3454';


  //OPCIONES GRAFICO 4
  showXAxis4: boolean = true;
  showYAxis4: boolean = true;
  gradient4: boolean = false;
  showLegend4: boolean = false;
  showXAxisLabel4: boolean = true;
  yAxisLabel4: string = 'Tarea';
  showYAxisLabel4: boolean = false;
  xAxisLabel4: string = 'Número de ejecuciones';


  




  seleccionaLocacion(seleccion){
    this.serviDataUnidadNegocioServiceService.unidadDeNegocioSeleccionada = seleccion
  }




alerta(tipo,input){
  this.alertaActiva=true;
  this.mensajeAlerta=input;
  this.tipodeAlerta=tipo;
}



closeAlert(){
  this.alertaActiva=false
}



arrayDataset=[]

customScript(){
  let arrayresultados=[]

  let  fechaquerymin = this.servicioFechasQueryService.fechaquerymin
  let  fechaquerymax = this.servicioFechasQueryService.fechaquerymax
  let  query:any  

    query = firebase.firestore().collection("ptws").where("fechainicio", ">=", fechaquerymin).where("fechainicio", "<=", fechaquerymax).where("unidadDeNegocio","==",this.unidadDeNegocioSeleccionada).where("pozoSeleccionado","==","Charapa");
     
  
    query.get().then((docs)=>{
      docs.forEach((doc)=>{
        arrayresultados.push(doc.data())

       // console.log(doc.data().fechainicio+"|"+doc.data().fechafinal+"|"+doc.data().pozoSeleccionado+"|"+doc.data().empresa+"|"+ this.retornaEmpleados(doc.data().arrayDeEmpleados) +"|"+doc.data().descripcionPTW+"|"+doc.data().ticket+"|"+ doc.data().arrayActividadesPTW  )
      })
    }).catch((err)=>{
      console.log(err);
    }).then(()=>{
      this.procesaData(arrayresultados);
    })
 }


procesaData(arrayresultados){
  let salidavisible=[]
  
  
  arrayresultados.forEach((element,index) => {
    let desgloseEmpleados=""
    let desgloseActividades=""

    element.arrayDeEmpleados.forEach((empleado) => {
      desgloseEmpleados += empleado.nombre+" - "
    });

    element.arrayActividadesPTW.forEach((actividad) => {
      desgloseActividades += actividad.actividad +" - "
    });

    salidavisible.push(
      {
        ticket:element.ticket,
        fechainicio:element.fechainicio,
        fechafinal:element.fechafinal,
        locacion:element.pozoSeleccionado,
        empresa:element.empresa,
        empleados:desgloseEmpleados,
        descripcionPTW:element.descripcionPTW,
        ActividadesPTW:desgloseActividades,
        
      }

    )


    if(index == arrayresultados.length -1 ){
      console.log(salidavisible)
      this.excelServiceService.generaexcel(salidavisible);
    }

  });
}


 retornaEmpleados(array){
  let salida = ""
  array.forEach((element, index) => {
    salida = salida+element.nombre+" - "
    if(index == array.length-1){
      return salida
    }
  });
 }


}//fin de clase
